// extracted by mini-css-extract-plugin
export default {"container":"gauge__container___kqI2N","value":"gauge__value___2u2tB","label":"gauge__label___3ljC0"};